import axios from 'axios';
import qs from 'qs';
import router from '@/router';
import store from '@/store';
import {Loading, Message, MessageBox, Notification} from 'element-ui'
import {delCookie, deleteSessionStorage, getCookie} from '@/utils/base.js';
import defaultSettings from '@/config/env'
import {saveAs} from 'file-saver'
import {blobValidate} from "@/utils/validate";
import {tansParams} from "@/utils/util";
import errorCode from '@/utils/errorCode'
import cache from '@/plugins/cache'

axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'; //配置请求头
axios.defaults.baseURL = '/api'; //配置接口地址
axios.defaults.withCredentials = true;
axios.defaults.responseType = 'json';

//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
  const isLogin = getCookie('isLogin');
  const token = getCookie('token');
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  // 是否需要防止数据重复提交
  const isRepeatSubmit = (config.headers || {}).repeatSubmit === false

  if (isLogin && token && !isToken) {
    config.headers['token'] = token
  }
  // config.headers['appId'] = defaultSettings.APP_ID
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?' + tansParams(config.params);
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }

  if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
    const requestObj = {
      url: config.url,
      data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
      time: new Date().getTime()
    }
    const sessionObj = cache.session.getJSON('sessionObj')
    if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
      cache.session.setJSON('sessionObj', requestObj)
    } else {
      const s_url = sessionObj.url;                  // 请求地址
      const s_data = sessionObj.data;                // 请求数据
      const s_time = sessionObj.time;                // 请求时间
      const interval = 1000;                         // 间隔时间(ms)，小于此时间视为重复提交
      if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
        const message = '数据正在处理，请勿重复提交';
        console.warn(`[${s_url}]: ` + message)
        return Promise.reject(new Error(message))
      } else {
        cache.session.setJSON('sessionObj', requestObj)
      }
    }
  }
  return config;
}, (error) => {
  console.log('错误的传参')
  return Promise.reject(error);
});

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200;
  // 获取错误信息
  const msg = errorCode[code] || res.data.msg || errorCode['default']

  // 二进制数据则直接返回
  if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
    return res.data
  }
  //未成功处理
  if (res.data.code !== 200) {
    if (res.data.code === 401) {
      delCookie('isLogin');
      delCookie('baseInfo');
      deleteSessionStorage('manager_role_list');
      deleteSessionStorage('manager_auth_list');
      /*删除stores数据*/
      store.commit('user/setState', {key: 'roles', val: null});
      router.push({
        path: '/login',
        query: {}
      });
      return Promise.reject(res.data);
    } else {
      let msg = res.data.msg;
      if (res.data.code === 5001) {
        msg = res.data.data[0];
      } else if (res.data.code === 5000) {
        msg = res.data.data;
      }
      Message({
        message: msg,
        type: "error"
      });
      return Promise.reject(res.data);
    }
  }
  return res.data;
}, (error) => {
  Message({
    message: error || '接口请求异常，请稍后再试~',
    type: "error"
  });
  return Promise.reject(error);
});

/**
 * 返回一个Promise(发送post请求)
 * errorback是否错误回调
 */
export function _post(url, params, errorback) {
  //在发送请求之前做某件事
  if (url != '/shop/file.upload/image'
    && url != '/shop/order.operate/batchDelivery') {
    params = qs.stringify(params);
  }
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      })
  })
}

/**
 * 返回一个Promise(发送get请求)
 * errorback是否错误回调
 */
export function _get(url, param, errorback) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: param
    })
      .then(response => {
        resolve(response)
      })
      .catch((error) => {
        reject(error);
      })
  })
}

/**
 * 返回一个Promise(发送上传请求)
 * errorback是否错误回调
 */
export function _upload(url, formData, errorback) {
  return new Promise((resolve, reject) => {
    axios.post(url, formData, {"Content-Type": "multipart/form-data", headers: {repeatSubmit: false}})
      .then(response => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      })
  })
}

/**
 * 返回一个Promise(发送post请求)
 * errorback是否错误回调
 */
export function _postBody(url, params, errorback) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, {headers: {'Content-Type': 'application/json;charset=UTF-8'}})
      .then(response => {
        resolve(response);
      })
      .catch((error) => {
        errorback && reject(error);
      })
  })
}


// 通用下载方法
// 通用下载方法
export function _download(url, params, filename, config, errorback) {
  const downloadLoadingInstance = Loading.service({
    text: "正在下载数据，请稍候",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
  });

  return axios.post(url, params, {
    transformRequest: [(params) => {
      return qs.stringify(params);
    }],
    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    responseType: 'blob',
    ...config
  }).then(async (response) => {
    const isBlobValid = await blobValidate(response);
    if (isBlobValid) {
      const blob = new Blob([response]);
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      const resText = await data.text();
      const rspObj = JSON.parse(resText);
      const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
      Message.error(errMsg);
    }
  }).catch((error) => {
    console.error('Download error:', error);
    Message.error('下载文件出现错误，请联系管理员！');
  }).finally(() => {
    downloadLoadingInstance.close();
  });
}

export default {
  _post,
  _get,
  _upload,
  _postBody,
  _download
}



// WEBPACK FOOTER //
// ./src/utils/request.js